module.exports = __webpack_public_path__ + "static/media/image_20.acf23bf9.png";